export const environment = {
  production: true,
  host: "onco-net.kumc.edu"
};
